import { RewardType } from '@loyalty/shared-common/rewards-api-client';
import { z } from 'zod';
import { $NaturalNumber, i18nAttributes, uuid } from '../../utils';
import { extendApi } from '../../openapi';
import { publicPromocodeRef } from './promocode';
import { publicRuleRef } from './rule';

export const publicProfileReward = extendApi(
  z.object({
    i18nAttributes: i18nAttributes(
      extendApi(
        z.object({
          name: z.string(),
          description: z.string().optional(),
        }),
        {
          examples: [
            {
              name: '10% off',
              description: '10% off on your next purchase',
            },
            {
              name: '-10%',
              description: '-10% sur votre prochain achat',
            },
          ],
        },
      ),
    ),
    rewardId: extendApi(uuid, {
      description: 'The id of the reward',
    }),
    rewardType: extendApi(z.nativeEnum(RewardType), {
      description: 'The type of the reward',
    }),
    rule: extendApi(publicRuleRef.optional(), {
      description:
        'Rule used by the member to obtain this reward. Empty if the reward was offered.', // only displayed in OAS 3.1
    }).optional(),
    totalCodes: extendApi($NaturalNumber, {
      description: 'Number of codes imported for this reward',
      example: 100,
    }),
    wonCodes: extendApi($NaturalNumber, {
      description: 'Number of codes won by members',
      example: 156,
    }),
    promocode: extendApi(publicPromocodeRef, {
      description: 'Promocode assigned to the member for this reward', // only displayed in OAS 3.1
    }),
  }),
  {
    tags: ['reward-model', 'reward', 'model'],
  },
);

export const publicRewardRef = extendApi(publicProfileReward, {
  $ref: '#/components/schemas/ProfileReward',
});

export type PublicProfileReward = z.infer<typeof publicProfileReward>;
